export const USER_DELETE_RESET = 'USER_DELETE_RESET'
export const USER_DELETE_SET_ERROR = 'USER_DELETE_SET_ERROR'
export const USER_DELETE_SET_DELETED = 'USER_DELETE_SET_DELETED'
export const USER_DELETE_TOGGLE_LOADING = 'USER_DELETE_TOGGLE_LOADING'
